var BASWebServices;
(function (BASWebServices) {
    var GetInventarButtonController = (function () {
        function GetInventarButtonController($scope, $window, configService) {
            this.$scope = $scope;
            this.$window = $window;
            this.configService = configService;
            $scope.gibc = this;
        }
        GetInventarButtonController.prototype.getInventarButtonClicked = function (language) {
            this.$window.open(BASWebServices.ConfigService.GET_GET_INVENTAR_SERVICE_URL() + "?LANGUAGE=" + language);
        };
        return GetInventarButtonController;
    }());
    BASWebServices.GetInventarButtonController = GetInventarButtonController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=GetInventarButtonController.js.map